import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router';

import { Button, Card, Page, Input, Stack, Heading2, Text, u, Inline } from '@ui';

import { useUserResetPassword } from '../../hooks';

import * as css from './UserResetPasswordScreen.css';

interface FormValues {
    email: string;
}

type EmailSentScreenProps = {
    email: string;
};
export const EmailSentScreen = ({ email }: EmailSentScreenProps) => {
    const navigate = useNavigate();

    return (
        <Page>
            <Card>
                <Stack gap={u(2.5)} style={{ width: '350px' }}>
                    <Heading2>Check Your Email</Heading2>
                    <Text>
                        An email has been sent to <strong>{email}</strong> with detailed instructions to reset your
                        password. Please follow the steps provided to complete the process.
                    </Text>
                    <Text>
                        Once your password has been reset, you can return to the home screen and log in as usual.
                    </Text>
                    <Button onClick={() => navigate('/')}>Return to login</Button>
                </Stack>
            </Card>
        </Page>
    );
};
export const UserResetPasswordScreen = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const resetPassword = useUserResetPassword();

    const form = useForm<FormValues>({
        defaultValues: {
            email: params.get('email') || '',
        },
    });

    const email = form.watch('email');
    const isSubmitted = form.formState.isSubmitSuccessful;

    if (isSubmitted) {
        return <EmailSentScreen email={email} />;
    }

    return (
        <Page>
            <Card>
                <form onSubmit={form.handleSubmit((data) => resetPassword.mutateAsync(data))}>
                    <Stack gap={u(2.5)} alignItems="center" justifyContent="center" className={css.formContainer}>
                        <Heading2>Reset your password</Heading2>

                        <Text>
                            Please enter your email address, and we will send you instructions to reset your password.
                        </Text>

                        <Input
                            label="Your email"
                            type="email"
                            placeholder="Enter your email"
                            {...form.register('email', {
                                required: 'Email is required',
                            })}
                        />

                        <Inline width="100%" justifyContent="space-between">
                            <Button type="button" variant="secondary" onClick={() => navigate('/')}>
                                Cancel
                            </Button>

                            <Button type="submit" isLoading={resetPassword.isPending}>
                                Send reset link
                            </Button>
                        </Inline>
                    </Stack>
                </form>
            </Card>
        </Page>
    );
};
